/* Modulae display formatting. Inputs remain Shopify integer price units (100 per major unit). */
(function (window) {
  'use strict';
  const theme = window.SugarTheme = window.SugarTheme || {};
  if (theme.money) return;

  const tokens = {
    amount: [2, ',', '.'],
    amount_no_decimals: [0, ',', '.'],
    amount_with_comma_separator: [2, '.', ','],
    amount_no_decimals_with_comma_separator: [0, '.', ','],
    amount_with_apostrophe_separator: [2, "'", '.'],
    amount_with_space_separator: [2, ' ', ','],
    amount_no_decimals_with_space_separator: [0, ' ', ','],
    amount_with_period_and_space_separator: [2, ' ', '.']
  };

  function format(cents, options = {}) {
    const shopify = window.Shopify;
    const config = theme.config || {};
    const currency = options.currency ?? config.currency ?? shopify?.currency?.active ?? window.__currencyCode;
    const locale = options.locale || config.locale || shopify?.locale || window.document?.documentElement?.lang || undefined;
    const showCode = options.showCurrencyCode ?? config.showCurrencyCode ?? window.__currencyCodeEnabled ?? false;
    let moneyFormat = options.moneyFormat === undefined ? (config.moneyFormat ?? window.theme?.moneyFormat) : options.moneyFormat;
    const formatCurrency = options.moneyFormatCurrency ?? config.moneyFormatCurrency ?? window.theme?.moneyFormatCurrency;
    if (currency && formatCurrency && currency !== formatCurrency) moneyFormat = null;
    let formatted;

    if (moneyFormat) {
      formatted = moneyFormat.replace(/{{\s*([^{}]*?)\s*}}/g, function (_, token) {
        token = token.trim();
        if (!Object.hasOwn(tokens, token)) throw new RangeError('Unsupported money format token: ' + token);
        const spec = tokens[token];
        const precision = options.stripDecimals ? 0 : spec[0];
        const amount = options.stripDecimals ? Math.round(cents / 100) : cents / 100;
        const parts = amount.toFixed(precision).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, spec[1]);
        return parts.join(spec[2]);
      });
    } else {
      const config = currency
        ? { style: 'currency', currency, currencyDisplay: 'narrowSymbol' }
        : { minimumFractionDigits: 2, maximumFractionDigits: 2 };
      if (options.stripDecimals) {
        config.minimumFractionDigits = 0;
        config.maximumFractionDigits = 0;
      }
      // Preserve the original consumers' display rounding, including fractional-cent inputs.
      const amount = options.stripDecimals ? Math.round(cents / 100) : (cents / 100).toFixed(2);
      formatted = new Intl.NumberFormat(locale, config).format(amount);
    }
    if (!currency) return formatted;
    const code = new RegExp('\\b' + currency + '\\b', 'g');
    if (!showCode) return moneyFormat ? formatted.replace(code, '').trim() : formatted;
    return code.test(formatted) ? formatted : formatted + ' ' + currency;
  }

  theme.money = Object.freeze({ format });
})(window);
